import cn from 'classnames';
import { FC } from 'react';

import { useAppSelector } from '@/shared/hooks';
import { getInitials, getName } from '@/shared/lib';
import { Avatar } from '@/shared/ui';

import { patientModel } from '@/entities/patient';
import { userModel } from '@/entities/user';

import { NewReportMenu } from '../NewReportMenu/NewReportMenu';
import { PatientPersonalInfo } from '../PatientPersonalInfo/PatientPersonalInfo';

import styles from './PatientHeaderV2.module.scss';

type PatientHeaderV2Props = {
  patientID: string;
  canEditPatient: boolean;
  showOrderReport: boolean;
  className?: string;
  onEditPatient: () => void;
};

export const PatientHeaderV2: FC<PatientHeaderV2Props> = (props) => {
  const {
    patientID,
    canEditPatient,
    showOrderReport,
    className,
    onEditPatient,
  } = props;

  const userLocale = useAppSelector(userModel.selectors.selectUserLocale);
  const patient = useAppSelector(
    patientModel.selectors.selectPatientByID(patientID),
  );

  const patientName = getName(
    patient?.PersonalData?.FirstName,
    patient?.PersonalData?.LastName,
    { userLocale },
  );

  return (
    <header
      className={cn(styles.container, className)}
      data-section="patient-profile"
    >
      <Avatar
        size={72}
        initials={getInitials(patientName)}
        className={styles.avatar}
        data-ph-mask
      />

      <div className={styles.identity}>
        <PatientPersonalInfo
          canEditPatient={canEditPatient}
          nameClassName={styles.name}
          onEditPatient={onEditPatient}
        />
      </div>

      {showOrderReport && <NewReportMenu className={styles.action} />}
    </header>
  );
};
